module.exports = __webpack_public_path__ + "static/img/dewbk.2ed2bbb.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/dewbk.jpg
// module id = 9QcF
// module chunks = 1